(function () {
  if (window.__tnwsLandingScrollBound) return;
  window.__tnwsLandingScrollBound = true;

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-tnws-landing-scroll]');
    if (!link) return;

    const targetSelector = link.getAttribute('href');
    if (!targetSelector || !targetSelector.startsWith('#')) return;

    const target = document.querySelector(targetSelector);
    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
